// Form delivery settings — every website form submits to this endpoint.
//
// Provider: FormSubmit (https://formsubmit.co) — no backend or account required.
// 1. The FIRST submission sends an "Activate Form" email to the recipient below.
//    Open that email in the info@ inbox and click the activation link.
// 2. Until activation, the form service returns an error and the site shows an error message.
// 3. After activation, FormSubmit also emails a random alias string. Replace the email address
//    in `formEndpoint` with that alias to keep the address out of the page source.
//
// To switch provider (e.g. Formspree or Web3Forms), change `formEndpoint` and, if needed,
// the response check in utils/formSubmission.ts.
export const formRecipient = 'info@risingtalentpartners.com';
export const formEndpoint = `https://formsubmit.co/ajax/${formRecipient}`;
